import { ApiKeyUsageDetail } from '../../../../utils/openai-api';
import { EmployeeRecord } from '@/utils/employee-indexeddb';
import { buildIdentifierVariants } from '../../utils/organization';

// ── findEmployeeForApiKey ──────────────────────────────

export function findEmployeeForApiKeyFn(
  apiKey: ApiKeyUsageDetail,
  employeeData: Map<string, EmployeeRecord>
): EmployeeRecord | undefined {
  const getEmployeeByKey = (key: string): EmployeeRecord | undefined => {
    return employeeData.get(key) ?? employeeData.get(key.toLowerCase());
  };

  const candidateKeys = new Set<string>();
  buildIdentifierVariants(apiKey.id).forEach(value => candidateKeys.add(value));
  if (Array.isArray(apiKey.sourceIds)) {
    apiKey.sourceIds.forEach(sourceId => {
      buildIdentifierVariants(sourceId).forEach(value => candidateKeys.add(value));
    });
  }

  for (const candidate of candidateKeys) {
    const employee = getEmployeeByKey(candidate);
    if (employee) {
      return employee;
    }
  }

  if (apiKey.name) {
    const apiKeyNameLower = apiKey.name.toLowerCase();
    const nameCandidates = buildIdentifierVariants(apiKeyNameLower);
    for (const candidate of nameCandidates) {
      const employee = getEmployeeByKey(candidate);
      if (employee) {
        return employee;
      }
    }
    if (apiKeyNameLower.includes('@')) {
      const emailPrefix = apiKeyNameLower.split('@')[0];
      const prefixCandidates = buildIdentifierVariants(emailPrefix);
      for (const candidate of prefixCandidates) {
        const employee = getEmployeeByKey(candidate);
        if (employee) {
          return employee;
        }
      }
    }
  }

  return undefined;
}
